module.exports = __webpack_public_path__ + "static/media/img-7.d5eae235.jpg";